import { render } from "./mangle.vue?vue&type=template&id=c354b97a"
import script from "./mangle.vue?vue&type=script&lang=js"
export * from "./mangle.vue?vue&type=script&lang=js"

import exportComponent from "/home/minify-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__